import { Analytics } from '@genoa/analytics'
import { Stack } from '@chakra-ui/react'
import { Box } from '@chakra-ui/react'

import { useNavigation } from '../../../../../navigation'
import { useAnalytics } from '../../../../../providers'
import { Megaphone } from '../../../../assets'
import { Headline1, PrimaryButton, SmallText } from '../../../../components'
import { BasePageLayout } from '../../../../layouts'

export function CreditBuilderSunsetView() {
  const analytics = useAnalytics()
  const { navigateToLogIn } = useNavigation()

  const handleSplitRent = () => {
    analytics.logEvent(Analytics.Events.GET_STARTED_WITH_FLEXIBLE_RENT_CLICKED)
    navigateToLogIn()
  }

  return (
    <BasePageLayout analyticsScreenName={Analytics.Screens.SUNSET_CREDIT_BUILDER}>
      <Box minH="32px" />
      <Stack textAlign="center" alignItems="center">
        <Megaphone />
        <Stack mt="6" spacing="5">
          <Headline1>This offer is no longer available</Headline1>
          <SmallText>
            Sorry! We’re no longer accepting Credit Builder applications, but you can still build your credit. Sign up
            for Flexible Rent and get access to rent reporting while splitting your rent into smaller payments.
          </SmallText>
          <PrimaryButton onClick={handleSplitRent}>Get started with Flexible Rent</PrimaryButton>
        </Stack>
      </Stack>
    </BasePageLayout>
  )
}
